"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginMethod = exports.DeviceType = exports.ServiceType = exports.Currency = void 0;
var Currency;
(function (Currency) {
    Currency["KRW"] = "KRW";
    Currency["USD"] = "USD";
})(Currency = exports.Currency || (exports.Currency = {}));
var ServiceType;
(function (ServiceType) {
    ServiceType["RIDIBOOKS"] = "ridibooks";
    ServiceType["RIDISELECT"] = "ridiselect";
})(ServiceType = exports.ServiceType || (exports.ServiceType = {}));
var DeviceType;
(function (DeviceType) {
    DeviceType["PC"] = "pc";
    DeviceType["MOBILE"] = "mobile";
    DeviceType["PC_PWA"] = "pc_pwa";
    DeviceType["MOBILE_PWA"] = "mobile_pwa";
    DeviceType["PAPER"] = "paper";
    DeviceType["APP"] = "app";
})(DeviceType = exports.DeviceType || (exports.DeviceType = {}));
var LoginMethod;
(function (LoginMethod) {
    LoginMethod["WEB"] = "web";
})(LoginMethod = exports.LoginMethod || (exports.LoginMethod = {}));
//# sourceMappingURL=constants.js.map


// WEBPACK FOOTER //
// /static/node_modules/@ridi/event-client/dist/cjs/constants.js